import { StringBase } from '../StringBase';

export class AudioSpecificIndustryVerticals extends StringBase {}
